import React, { useState } from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { usePermissions } from "../hooks/usePermissions";
import { usePendingDeclarationPrefixes } from "../hooks/usePendingDeclarationPrefixes";
import { getPublisherPrefixLabel } from "../utils/pendingDeclaration";
import { PublisherPrefixDeclareModal } from "./PublisherPrefixDeclareModal";
import styles from "./PendingDeclarationPrompt.module.css";
/**
 * Actionable, in-place declaration prompt: lists the publisher's PENDING active prefixes (optionally
 * for a single agency) and opens the {@link PublisherPrefixDeclareModal} for the chosen one — so the
 * last-used-number can be declared inside the current flow instead of navigating to the buried
 * "Prefixy nakladatele" screen. Only rendered for users allowed to declare; declaring never assigns a
 * number, it only unblocks the flow via {@link onDeclared}.
 */
export var PendingDeclarationPrompt = function (_a) {
    var publisherSourceId = _a.publisherSourceId, agency = _a.agency, onDeclared = _a.onDeclared, _b = _a.fallback, fallback = _b === void 0 ? null : _b;
    var canDeclareLastUsedNumber = usePermissions().canDeclareLastUsedNumber;
    var _c = usePendingDeclarationPrefixes({
        publisherSourceId: publisherSourceId,
        agency: agency,
        enabled: canDeclareLastUsedNumber,
    }), pendingPrefixes = _c.pendingPrefixes, isLoading = _c.isLoading;
    var _d = useState(null), declaringPrefix = _d[0], setDeclaringPrefix = _d[1];
    if (!canDeclareLastUsedNumber) {
        return React.createElement(React.Fragment, null, fallback);
    }
    if (isLoading) {
        return null;
    }
    if (pendingPrefixes.length === 0) {
        return React.createElement(React.Fragment, null, fallback);
    }
    var showLabel = pendingPrefixes.length > 1;
    return (React.createElement("div", { className: styles.prompt },
        React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.inline.hint" })),
        React.createElement("div", { className: styles.actions }, pendingPrefixes.map(function (prefix) { return (React.createElement(Button, { key: prefix.id, buttonStyle: "primary", marginBottom0: true, onClick: function () { return setDeclaringPrefix(prefix); } }, showLabel ? (React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.inline.action.forPrefix", values: { prefix: getPublisherPrefixLabel(prefix) } })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.title.products.panel.assign.reason.declarationPending.action" })))); })),
        declaringPrefix && (React.createElement(PublisherPrefixDeclareModal, { prefix: declaringPrefix, onClose: function () { return setDeclaringPrefix(null); }, onDeclared: function () {
                setDeclaringPrefix(null);
                onDeclared();
            } }))));
};
